function shouldBlockEnterOnSelectionControl(target) {
  if (!(target instanceof HTMLElement)) return false;

  if (target.closest('select')) return true;

  const selectionControl = target.closest('[role="combobox"], [data-au-input-predictive], [data-au-select]');
  if (!selectionControl) return false;

  const expandedControl =
    selectionControl.matches('[aria-expanded="true"]') ||
    Boolean(selectionControl.querySelector('[aria-expanded="true"]'));

  if (expandedControl) return true;

  const listboxId =
    selectionControl.getAttribute('aria-controls') ||
    selectionControl.querySelector('[aria-controls]')?.getAttribute('aria-controls');

  if (!listboxId) return false;

  const listbox = document.getElementById(listboxId);
  return Boolean(listbox && !listbox.classList.contains('au-visually-hidden'));
}

export default shouldBlockEnterOnSelectionControl;
